module.exports = __webpack_public_path__ + "img/组 6.c1b57efb.png";